import { render, staticRenderFns } from "./PdpReviews.vue?vue&type=template&id=334c5f3e"
import script from "./PdpReviews.vue?vue&type=script&setup=true&lang=ts"
export * from "./PdpReviews.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PdpReviews.vue?vue&type=style&index=0&id=334c5f3e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports